import React from 'react';
import { withStyles } from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import UIButton from '../../core/ui/button.js';
import Survey001 from './surveys/survey001.js'

const styles = theme => ({
  root: {
    position: 'fixed',
    display: 'block',
    bottom: '0',
    right: '0',
    padding: 10,
    margin: 10,
  },
  body :{
    padding: 10,
    marginRight: 25,
    marginBottom: 10,
    width: 280,
    position: 'fixed',
    right: 0,
    bottom: 70,
    borderRadius: 5,
    border: '1px solid #808080',
  },
  thanks : {
    width : '100%',
    textAlign: 'center',
    fontSize: '14px',
    paddingTop: 20,
    paddingBottom: 20,
  },
  button : {
    border: '4px solid white',
  },
});

class Survey extends React.Component {
  constructor(){
    super();

    this.state = {
      opened : false,
      responded : false,
      response: null,
    };
  }

  onOpen(){
    this.setState({opened : !this.state.opened});
  }

  onClickResponse(data){
    const $this = this;
    this.setState({response : data}, function(){$this.sendData()}); 
  }

  onRespond(data){
    const $this = this;
    this.setState({responded : true, response : data}, function(){$this.sendData()}); 
  }

  sendData(){
    this.props.api.sendSurvey({id: '001', data: this.state.response});
  }


  render() {
    const classes = this.props.classes;
    var key = 0;
    return (
      <div className={classes.root}>
        {this.state.opened &&
          <Paper className={classes.body} elevation={24}>
          {!this.state.responded ? 
              <Survey001 onRespond={this.onRespond.bind(this)} onClickResponse={this.onClickResponse.bind(this)}/>
          :
            <div className={classes.thanks}>Gracias por tu opinion</div>
          }
          </Paper>
        }
        <UIButton className={classes.button} color={'accent'} fab={true} icon='question' onClick={this.onOpen.bind(this)}/>
      </div>
    );
  }              

}

export default withStyles(styles)(Survey);


// WEBPACK FOOTER //
// ./src/search/components/survey.js